<template>
  <div>
    <b-modal id="modalEditVoluntarySuspensionSettings" ref="modalEditVoluntarySuspensionSettings" @shown="shown"
      :title="$t('Voluntary suspension')" hide-footer>
      <div  v-if="editItem">
        <b-form-group label-align="right" v-if="editItem.id != 0" disabled label="ID" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.id" disabled/>
        </b-form-group>
        <b-form-group label-align="right" :disabled="editItem.id != 0" :label="$t('Group')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select v-model="editItem.group_id" :options="groups" :disabled="editItem.id != 0"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Active')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-checkbox switch size="lg" v-model="editItem.is_enabled" value="1" unchecked-value="0" />
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Minimal duration(seconds)')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="editItem.min_duration" style="text-align:right"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Maximum duration(seconds)')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="editItem.max_duration" style="text-align:right"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Interval between uses (seconds)')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="editItem.interval_duration" style="text-align:right"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Min balance')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="editItem.min_balance" :disabled="editItem.use_min_balance == 0" style="text-align:right"/>
          <b-form-checkbox switch v-model="editItem.use_min_balance" value="1" unchecked-value="0" />
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Service')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select v-model="editItem.service_id" :options="onceServices" />
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Free if balance over')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="editItem.free_balance" :disabled="editItem.use_free_balance == 0" style="text-align:right"/>
          <b-form-checkbox switch v-model="editItem.use_free_balance" value="1" unchecked-value="0" />
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Self unlock')" label-cols="4" label-cols-xl="4" label-cols-md="4">
           <b-form-checkbox switch size="lg" v-model="editItem.self_unlock" value="1" unchecked-value="0" />
        </b-form-group>

        <modal-ok-cancel @save="save" @cancel="$bvModal.hide('modalEditVoluntarySuspensionSettings')" size="md"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null
  },
  methods: {
    save () {
      let response = this.editItem.id !== 0
        ? this.$store.dispatch('Settings/UPDATE_VOLUNTARY_SUSPENSION_SETTINGS', this.editItem)
        : this.$store.dispatch('Settings/CREATE_VOLUNTARY_SUSPENSION_SETTINGS', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_VOLUNTARY_SUSPENSION_SETTINGS')
          this.$refs.modalEditVoluntarySuspensionSettings.hide()
          this.$root.$emit('makeToasts')
        }
      })
    },
    shown () {
      if (this.editItem.id === 0 && this.groups.length) {
        this.editItem.group_id = this.groups[0].value
      }
    }
  },
  computed: {
    groups () {
      let res = []
      for (let el of this.$store.getters['Users/GROUPS']) {
        if (this.editItem.id === 0) {
          let isAlreadyHas = false
          for (let elPS of this.voluntarySuspensionSettings) {
            if (elPS.group_id === el.group_id) {
              isAlreadyHas = true
              break
            }
          }
          if (isAlreadyHas) {
            continue
          }
        }
        let newEl = {}
        newEl.value = el.group_id
        newEl.text = el.group_name
        res.push(newEl)
      }
      if (this.editItem.id === 0) {
        let isAlreadyHas = false
        for (let elPS of this.voluntarySuspensionSettings) {
          if (elPS.group_id === 0) {
            isAlreadyHas = true
            break
          }
        }
        if (!isAlreadyHas) {
          res.push({value: 0, text: this.$t('All')})
        }
      } else {
        res.push({value: 0, text: this.$t('All')})
      }
      return res
    },
    voluntarySuspensionSettings () {
      return this.$store.getters['Settings/VOLUNTARY_SUSPENSION_SETTINGS']
    },
    onceServices () {
      let res = []
      for (let el of this.$store.getters['Tariffing/SERVICES']) {
        if (el.service_type !== 1) {
          continue
        }
        let newEl = {}
        newEl.value = el.service_id
        newEl.text = el.service_name
        res.push(newEl)
      }
      res.push({value: 0, text: this.$t('No')})
      return res
    }
  },
  mounted () {
    this.$store.dispatch('Tariffing/GET_SERVICES')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/customerPortal/voluntarySuspension/editModal.vue